import moment from "moment";
import TraingleIcon from "../../../../svg/triangle";
import FileImageVideo from "./FileImageVideo";
import FileOthers from "./FileOthers";

export default function FileMessage({ FileMessage, message, me, showAvatarAndTail = true }) {
  const { file, type } = FileMessage;
  const senderPicture = message?.sender?.picture;
  const senderName = message?.sender?.name;
  const isFromAdmin = message?.metadata?.sentByAdmin;
  const adminName = message?.metadata?.adminName;
  const displayName = me ? (isFromAdmin ? (adminName || senderName || 'مدير') : 'الذكاء الاصطناعي') : null;
  const avatarUrl = me ? (senderPicture || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(displayName || 'AI') + '&background=005C4B&color=fff') : senderPicture;
  const deliveryStatus = (message?.metadata?.deliveryStatus || "").toLowerCase();
  const readIndicator = !me ? "" : (
    ["read", "seen"].includes(deliveryStatus)
      ? "✓✓"
      : ["delivered"].includes(deliveryStatus)
        ? "✓✓"
        : ["sent", "queued", "pending"].includes(deliveryStatus)
          ? "✓"
          : ["failed"].includes(deliveryStatus)
            ? "!"
            : ""
  );
  return (
    <div
      className={`w-full flex mt-2 gap-2 max-w-[85%] z-10 ${
        me ? "ms-auto justify-end flex-row-reverse" : ""
      }`}
    >
      {/*Sender avatar - show only on last message of group; placeholder when hidden */}
      {showAvatarAndTail ? (
        (me ? avatarUrl : senderPicture) && (
          <div className="shrink-0 self-end flex flex-col items-center gap-0.5">
            <img
              src={me ? avatarUrl : senderPicture}
              alt=""
              className="w-8 h-8 rounded-full object-cover"
            />
            {me && displayName && (
              <span className="text-[10px] text-dark_text_2 truncate max-w-[3rem]">{displayName}</span>
            )}
          </div>
        )
      ) : (
        <div className="w-8 shrink-0" aria-hidden />
      )}
      {/*Message Container*/}
      <div className="relative w-fit max-w-[70%]">
        <div
          className={`relative h-full dark:text-dark_text_1 rounded-lg min-w-0
        ${me ? " border border-green_3" : "dark:bg-dark_bg_2"}
        ${
          me && file?.public_id?.split(".")[1] === "png"
            ? "bg-white"
            : "bg-green_3 p-1"
        }
        `}
        >
          {/*Message*/}
          <p
            className={`h-full text-sm ${
              type !== "IMAGE" && type !== "VIDEO" ? "pb-5" : ""
            }`}
          >
            {type === "IMAGE" || type === "VIDEO" ? (
              <FileImageVideo url={file.secure_url} type={type} />
            ) : (
              <FileOthers file={file} type={type} me={me} />
            )}
          </p>
          {/*Message Date*/}
          <span className="absolute end-1.5 bottom-1.5 text-xs text-dark_text_5 leading-none flex items-center gap-1">
            <span>{moment(message.createdAt).format("HH:mm")}</span>
            {readIndicator && <span className="text-[11px]">{readIndicator}</span>}
          </span>
          {/*Traingle - show only on last message of group */}
          {showAvatarAndTail && (!me ? (
            <span>
              <TraingleIcon className="dark:fill-dark_bg_2 rotate-[60deg] absolute top-[-5px] -start-1.5" />
            </span>
          ) : (
            <span>
              <TraingleIcon className="fill-green_3 rotate-[60deg] absolute top-[-5px] -end-2" />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}